import React, { useEffect, useState, useCallback } from 'react';

import { useSelector } from 'react-redux';

import dayjs from 'core/utils/dayjs';

import { runTimer, getTimeRemaining } from 'core/utils/helpers/date';

import Countdown from 'core/modules/Countdown/Countdown';
import MarketingLink from 'core/modules/MarketingLink/MarketingLink';

import { selectInfoBarMarketingConfig } from '../selectors';

function InfoBarMarketingTile({
  hasCountdown,
  countdownStopDatetime,
  stopDatetime,
  removeCallback,
  assets,
  clickUrl,
  id,
  responseDate,
  className = '',
}) {
  const [showCountdown, setShowCountdown] = useState(false);
  const [isOfferActive, setIsOfferActive] = useState(true);
  const [isMounted, setIsMounted] = useState(null);

  const config = useSelector(selectInfoBarMarketingConfig);
  const { tagHelper } = config;

  const removeInactiveOffer = useCallback(() => {
    // A hack to prevent a this.setState issue in case the tile was unmounded from the letterbox
    // but the runTimer complete handler was called
    if (isMounted) {
      setIsOfferActive(false);
      removeCallback && removeCallback();
    }
  }, [isMounted, removeCallback]);

  useEffect(() => {
    setIsMounted(true);
    if (!getTimeRemaining(stopDatetime) && !getTimeRemaining(countdownStopDatetime)) {
      removeInactiveOffer();
    }

    if (hasCountdown) {
      setShowCountdown(true);
    }

    return setIsMounted(false);
  }, [stopDatetime, countdownStopDatetime, hasCountdown, removeInactiveOffer]);

  const countDownCompleteHandler = () => {
    if (showCountdown) {
      setShowCountdown(false);
    }

    const hasCustomCountdownStopDate = !(dayjs(countdownStopDatetime).isSame(stopDatetime));

    if (hasCustomCountdownStopDate) {
      runTimer({
        endDate: stopDatetime,
        onComplete: () => { removeInactiveOffer(); },
      });
    } else {
      removeInactiveOffer();
    }
  };

  if (!isOfferActive) {
    return null;
  }

  return (
    <MarketingLink
      url={assets.callToActionUrl || clickUrl}
      className={className}
      data-placement-id={id}
      data-has-countdown={hasCountdown}
      tagHelper={tagHelper}
    >
      <div className="mn_infoBarMarketingContent">
        {showCountdown && (
          <div className="mn_infoBarMarketingCountdownWrap">
            <span className="mn_infoBarClockPrefixText">{assets.countdownClockPrefixText} </span>
            <Countdown
              startDate={responseDate}
              endDate={countdownStopDatetime}
              onComplete={() => countDownCompleteHandler()}
            />
          </div>
        )}

        <div className="mn_infoBarMarketingText">
          <h2 className="mn_shortSummaryText" dangerouslySetInnerHTML={{ __html: assets.shortSummaryText }} />
          <p className="mn_rolloverCopy" dangerouslySetInnerHTML={{ __html: assets.rolloverCopy }} />
        </div>

        <div className="mn_button">
          <span>{assets.callToActionText || 'Shop now'}</span>
        </div>
      </div>
    </MarketingLink>
  );
}

export default InfoBarMarketingTile;
